import React from "react"
import CalculatorsPostsLinksStyle from "./CalcultarorsPostsLinksStyle.module.styl"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft"

const CalculatorsPostsLinks = ({ internalLink }) => {
  console.log(internalLink)
  return (
    <div className={CalculatorsPostsLinksStyle.wrapper}>
      {internalLink.length === 1 ? (
        <Link
          className={CalculatorsPostsLinksStyle.next}
          to={`/${internalLink[0].slug}`}
        >
          Следваща
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      ) : (
        <div className={CalculatorsPostsLinksStyle.holder}>
          {" "}
          <Link
            className={CalculatorsPostsLinksStyle.prev}
            to={`/${internalLink[0].slug}`}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            Предишна
          </Link>
          <Link
            className={CalculatorsPostsLinksStyle.next}
            to={`/${internalLink[1].slug}`}
          >
            Следваща
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
      )}
    </div>
  )
}

export default CalculatorsPostsLinks
